export default {
  currentEditedOpportunity: {},
  languages: [],
};
